import React from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const info = {
  title: ' Группа компаний «Стройпром»',
  description:
    'является эксклюзивным дистрибьютором по Российской Федерации заводов по производству геосеток S&P, которые применяются в Калининградской области при строительстве новых дорог и при их ремонте с 2008 года, имеют только положительные отзывы при эксплуатации. Во время ремонта 23 улиц в г.Калининграде, при подготовке к ЧМ 2018 по футболу, по программе «Безопасные и качественные дороги» применялась геосетка S&P Glasphalt GV.',
};

const CompanyInfo = () => {
  const useStyles = makeStyles((theme) => ({
    heroContent: {
      padding: theme.spacing(6, 6, 6),
      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(2, 2, 2),
      },
    },
    description: {
      [theme.breakpoints.down('sm')]: {
        fontSize: '1.3rem',
      },
    },
    heroTitle: {
      [theme.breakpoints.down('xs')]: {
        marginTop: '2.5rem',
        fontSize: '2.5rem',
      },
    },
  }));
  const classes = useStyles();
  return (
    <Container component="main" className={classes.heroContent}>
      <Typography
        component="h1"
        variant="h2"
        align="center"
        color="textPrimary"
        gutterBottom
        className={classes.heroTitle}
      >
        {info.title}
      </Typography>
      <Typography
        className={classes.description}
        variant="h5"
        align="center"
        color="textSecondary"
        component="p"
      >
        {info.description}
      </Typography>
    </Container>
  );
};
export default CompanyInfo;
